import { Modal } from 'antd';
import deleteValuationFile from '../../../Services/deleteValuationFile';

const { confirm } = Modal;

export default () => async (dispatch) => {

  confirm({
    title: `Are you sure you want to delete this Payment Certificate?`,
    content: 'Note: This action cannot be undone',
    okText: 'Yes, Delete it',
    onOk() {
      
      dispatch(deleteValuationFile());
      
    }
  });

}